import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/AdminProperties.css";

function AdminProperties() {

  const [properties, setProperties] = useState([]);
  const navigate = useNavigate();

  
  useEffect(() => {

    fetch("https://urbanbrick.in.net/get-properties.php")
      .then(res => res.json())
      .then(data => {
        setProperties(data);
      })
      .catch(err => console.log(err));

  }, []);

  
  const handleDelete = (id) => {

    const confirmDelete = window.confirm("Are you sure?");

    if (!confirmDelete) return;

    fetch("https://urbanbrick.in.net/delete-property.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ id })
    })
      .then(res => res.json())
      .then(data => {

        if (data.status === "success") {

          setProperties(prev =>
            prev.filter(item => item.id !== id)
          );

          alert("Deleted Successfully");

        } else {
          alert("Delete failed");
        }

      })
      .catch(err => console.log(err));

  };

  return (

    <div className="main-layout">

      {/* SIDEBAR */}
      <div className="sidebar">

        <h2 className="logo">🏠 RealEstate</h2>

        <ul>
          <li onClick={() => navigate("/admin/dashboard")}>
            Dashboard
          </li>

          <li className="active">
            Properties
          </li>

          <li onClick={() => navigate("/admin/buys")}>
            Buys
          </li>

          <li onClick={() => navigate("/admin/sales")}>
            Sales
          </li>

          <li onClick={() => navigate("/admin/rents")}>
            Rents
          </li>

          <li onClick={() => navigate("/admin/messages")}>
            Messages
          </li>

          <li onClick={() => navigate("/admin/settings")}>
            Settings
          </li>
        </ul>

      </div>

      {/* MAIN */}
      <div className="dashboard-container">

        <div className="topbar">

          <div className="search-box">
            🔍 <input placeholder="Search..." />
          </div>

          <button onClick={() => navigate("/add")}>
            + Add Property
          </button>

        </div>

        <h2>All Properties</h2>

        {properties.length === 0 ? (

          <p>No properties found</p>

        ) : (

          <table>

            <thead>
              <tr>
                <th>Property</th>
                <th>Location</th>
                <th>Price</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>

              {properties.map((p) => (

                <tr key={p.id}>

                  <td>
                    {p.listingType}
                  </td>

                  <td>{p.location}</td>

                  <td>₹ {p.price}</td>

                  <td>

                    <button
                      onClick={() =>
                        navigate(`/property/${p.id}`)
                      }
                    >
                      View
                    </button>

                    <button
                      onClick={() =>
                        navigate(`/edit/${p.id}`)
                      }
                    >
                      Edit
                    </button>

                    <button
                      onClick={() =>
                        handleDelete(p.id)
                      }
                    >
                      Delete
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        )}

      </div>

    </div>

  );

}

export default AdminProperties;